import { ele } from "cables-shared-client";
import web from "../../index.js";
import api from "../../api.js";

export default class PageAdminBackups
{
    constructor(targetElement)
    {
        const url = new URL(window.location.href);
        this._order = url.searchParams.get("or") || "count";

        const orderTabs = ele.byQueryAll("#order-tab-bar li");
        orderTabs.forEach((orderTab) =>
        {
            if (orderTab.classList.contains(this._order)) orderTab.classList.add("active");
            orderTab.addEventListener("click", () =>
            {
                const sort = orderTab.dataset.sort;
                window.location.search = "?or=" + sort;
            });
        });

        let limit = url.searchParams.get("l") || 50;
        let offset = url.searchParams.get("o") || 0;
        const apiUrl = web.tabs.addPagination("admin/backups?or=" + this._order, limit, offset);

        const resultEle = ele.byId("backup_table");
        const statusEle = ele.byId("status");
        api.get(apiUrl, (res) =>
        {
            const userTable = { "cols": [], "rows": [] };
            if (res.data && res.data.patches)
            {
                res.data.patches.forEach((p) =>
                {
                    let sizeMb = p.sizeMb || 0;
                    let parsed = parseFloat(sizeMb);
                    if (!parsed) parsed = 0;
                    parsed = parsed.toFixed(2);

                    const row = [
                        "<a href=\"/p/" + p.projectId + "\">" + p.name + "</a>",
                        p.numBackups + " Backups",
                        parsed + " MB"
                    ];
                    userTable.rows.push(row);
                });
            }
            statusEle.innerText = res.data.count + " backups in " + res.data.patchCount + " patches (" + res.data.sizeGb + "GB)";
            if (this._order === "size") statusEle.innerText += " - showing biggest first.";
            if (this._order === "count") statusEle.innerText += " - showing \"most backups\" first.";
            ele.show(statusEle);
            web.setHandleBarHtml("table", userTable, resultEle);
            web.tabs.initPagination(resultEle, res.pagination, limit, offset);
        }, (err) =>
        {
            resultEle.innerText = err;
        });
    }

}
